import httpMessage from './httpMessage.json'
import common from './common.json'

export default {
  httpMessage,
  common,
}
